// extracted by css-extract-rspack-plugin
export default {"wrapper":"_41bf2b7f"};